// extracted by mini-css-extract-plugin
export default {"cards":"Prizes_cards__Ka8gg"};